import role from './role';

export default [ role ];